import { render } from "./CadastroIdiomasView.vue?vue&type=template&id=8ab2b75e"
import script from "./CadastroIdiomasView.vue?vue&type=script&lang=js"
export * from "./CadastroIdiomasView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\SGCAD25\\Multifianca\\FrontBack\\CodigoVue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__